export default {
  metaTitle: "USFans Spreadsheet 2026: Hallazgos completos y guía de compra",
  metaDescription:
    "Descubre la USFans Spreadsheet: hallazgos organizados, navegación por categorías, guías de compra, consejos de QC e información de envío. Independiente y actualizada.",
  heroEyebrow: "CENTRO DE RECURSOS DE USFANS SPREADSHEET",
  heroH1: "USFans Spreadsheet — descubre hallazgos, compara opciones y compra mejor",
  heroSub:
    "Explora los recursos más recientes de USFans Spreadsheet, hallazgos útiles, guías de compra, consejos de QC, información de envío, reseñas y consejos de seguridad — todo organizado en un solo lugar fácil de usar.",
  heroCta1: "USFans Spreadsheet",
  heroCta2: "Comprar ahora",
  heroTrust: "Recurso independiente · Guías actualizadas · Información de compra práctica",
  heroBadge: "Punto de partida de confianza para los hallazgos de USFans",
  categoriesH2: "Explora categorías de productos",
  categoriesSub:
    "Salta directo a la sección que necesitas en el sitio principal. Elige una categoría abajo o usa el menú desplegable de arriba.",
  categoriesGridH2: "Compra por categoría",
  categoriesGridSub: "Cada categoría enlaza directamente a los productos USFans correspondientes del sitio principal.",
  viewCategory: "Ver",
  valuePropsH2: "Todo lo que necesitas saber sobre USFans",
  valuePropsSub: "Un solo centro para los temas que más preguntan los compradores — explicado en lenguaje claro.",
  vp1Title: "USFans Spreadsheet",
  vp1Desc: "Descubre hallazgos útiles y recursos de productos organizados en un solo lugar.",
  vp1Cta: "Explorar hoja",
  vp2Title: "Reseñas de USFans",
  vp2Desc: "Entiende la plataforma, sus funciones, riesgos potenciales y consideraciones importantes.",
  vp2Cta: "Leer reseña de USFans",
  vp3Title: "Envío",
  vp3Desc: "Entiende los métodos de envío, los costos estimados y el seguimiento.",
  vp3Cta: "Ver guía de envío",
  vp4Title: "QC",
  vp4Desc: "Aprende qué revisar antes de aprobar productos y confirmar un pedido.",
  vp4Cta: "Aprender QC",
  vp5Title: "Seguridad",
  vp5Desc: "Aprende formas prácticas de reducir los riesgos de compra más comunes.",
  vp5Cta: "Visitar centro de seguridad",
  vp6Title: "Almacén",
  vp6Desc: "Entiende cómo funcionan el almacenamiento y el procesamiento de pedidos.",
  vp6Cta: "Leer guía del almacén",
  seoH2: "¿Por qué usar la USFans Spreadsheet?",
  seoP1:
    "La USFans Spreadsheet reúne el descubrimiento de productos en un solo lugar limpio. En lugar de saltar entre enlaces dispersos y páginas desactualizadas, puedes explorar categorías organizadas, comparar hallazgos similares e ir directo al sitio principal cuando estés listo para comprar. Está pensada para ahorrarte tiempo y reducir las dudas de las compras en línea.",
  seoP2:
    "Mantenemos este centro independiente y fácil de usar. Encontrarás recursos prácticos sobre categorías, control de calidad, envío y seguridad — escritos en lenguaje claro y actualizados con regularidad. Ya sea que busques zapatos, sudaderas, bolsos o accesorios, la hoja te da un punto de partida claro.",
  seoList1: "Categorías organizadas para navegar más rápido",
  seoList2: "Orientación de compra directa",
  seoList3: "Básicos de QC, envío y seguridad",
  seoList4: "Recursos actualizados con regularidad",
  seoReadMore: "Leer la guía completa",
  seoCardTitle: "USFans Spreadsheet 2026: Guía completa",
  seoCardDesc:
    "Qué es la hoja, cómo funciona, las categorías principales y cómo comprar con más confianza — en una guía detallada.",
  faqH2: "Preguntas frecuentes",
  faq1Q: "¿Qué es la USFans Spreadsheet?",
  faq1A:
    "Es un recurso organizado que agrupa los hallazgos de USFans por categoría, para que puedas explorar y comparar productos en un solo lugar.",
  faq2Q: "¿La USFans Spreadsheet es gratis?",
  faq2A:
    "Sí — explorar el recurso es gratis. Solo pagas cuando decides comprar a través del sitio principal.",
  faq3Q: "¿Cómo llego a los productos?",
  faq3A:
    "Elige una categoría desde el menú desplegable o las tarjetas, y serás llevado a la sección correspondiente del sitio principal.",
  finalCtaH2: "¿Listo para explorar la USFans Spreadsheet?",
  finalCtaSub: "Explora hallazgos organizados, compara categorías y compra mejor — todo en un solo lugar.",
  finalCtaPrimary: "Explorar USFans Spreadsheet",
  finalCtaSecondary: "Visitar el sitio principal",
  pillarH2: "Artículos pilar y guías",
  pillarSub: "Nuestros recursos de USFans más leídos — reseñas, envío, QC, seguridad y consejos de compra en un solo lugar.",
  pillarRead: "Leer guía",
  p1Title: "Reseña de USFans 2026",
  p1Desc: "¿USFans es legítimo y seguro? Una mirada sencilla a cómo funciona y qué revisar.",
  p2Title: "Guía de costos de envío de USFans",
  p2Desc: "Qué afecta el precio del envío y cómo comparar opciones antes de pedir.",
  p3Title: "Guía de cupones de USFans",
  p3Desc: "Cómo funcionan los cupones y dónde verificar las promociones de forma segura.",
  p4Title: "Guía de códigos de descuento de USFans",
  p4Desc: "Cómo encontrar y verificar los códigos de descuento actuales antes de comprar.",
  p5Title: "Guía del almacén de USFans",
  p5Desc: "Cómo funcionan el almacenamiento, el QC y el procesamiento de pedidos.",
  p6Title: "¿USFans es legítimo?",
  p6Desc: "Una mirada equilibrada a la confianza, los riesgos y cómo protegerte.",
  p7Title: "Guía de QC de USFans",
  p7Desc: "Qué inspeccionar antes de aprobar productos y confirmar un pedido.",
  p8Title: "Guía de compra de USFans",
  p8Desc: "Un camino paso a paso para pedir con más confianza.",
  p9Title: "Centro de seguridad de USFans",
  p9Desc: "Formas prácticas de reducir los riesgos de compra más comunes.",
  p10Title: "Seguimiento y envío de USFans",
  p10Desc: "Entiende los conceptos básicos de seguimiento y envío de tus pedidos.",
};